<template>
  <v-app light>
    <v-app-bar :height="bannerHeight" :src="getBannerSrc()" flat app>
      <template v-slot:img="{ props }">
        <v-img v-bind="props"></v-img>
      </template>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-row>
          <v-card v-show="showKeyInGuests" class="mx-auto" align="center" flat>
            <v-card-text class="text-h5 font-weight-bold mt-10" align="center">
              <div v-show="language === 'zh_TW'">用餐人數</div>
              <div v-show="language === 'en_US'">How many seats you need?</div>
            </v-card-text>
            <v-container>
              <v-row v-for="(rowItem, rowIndex) in keyboard" :key="`keyboard-row-${rowIndex}`">
                <v-col v-for="(colItem, colIndex) in rowItem" :key="`keyboard-col-${rowIndex}-${colIndex}`">
                  <v-btn class="text-h5 font-weight-bold" color="primary" @click="keyIn(colItem)" x-large block
                    outlined>{{
                      colItem }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
          <v-card v-show="showSelectTables" class="mx-auto" max-width="800" align="center" flat>
            <v-card-text class="text-h5 font-weight-bold mt-10" align="center">
              <div v-show="language === 'zh_TW'">用餐桌號</div>
              <div v-show="language === 'en_US'">Table</div>
            </v-card-text>
            <v-container>
              <v-row v-for="tableRow in (Math.ceil(tableInfoWithStatus.length / rowTableCount))"
                :key="`table-row-${tableRow}`">
                <v-col v-for="(tableItem, tableIndex) in
                  tableInfoWithStatus.slice((tableRow - 1) * rowTableCount, tableRow * rowTableCount)"
                  :key="`table-col-${tableIndex}`">
                  <v-btn class="text-h6 font-weight-bold" color="primary" @click="setTable(tableItem)" x-large
                    :outlined="tableItem.tableStatus === 1" rounded>
                    {{ tableItem.tableName }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <v-footer padless app color="white">
      <v-container fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="home" x-large block outlined>返回上一步
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
const mqttConfig = require('../modules/config.json').pos_mqtt;

const base64Encode = (str) => Buffer.from(str, 'utf-8').toString('base64');

export default {
  name: 'BeforeOrderPage',
  components: {},
  props: {},
  data: () => ({
    keyboard: [
      ['1', '2', '3'],
      ['4', '5', '6'],
      ['7', '8', '9'],
    ],
    showKeyInGuests: false,
    showSelectTables: false,
    rowTableCount: 3,
    tableInfoWithStatus: [],
  }),
  methods: {
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    setTable(tableInfo) {
      this.$store.dispatch('setOrderContent', { tableId: tableInfo.tableId });
      this.goNext();
    },
    keyIn(char) {
      this.$store.dispatch('setOrderContent', { guests: char });
      if (this.tableInfoWithStatus.length > 0) {
        this.getTableStatus();
        this.showKeyInGuests = false;
        this.showSelectTables = true;
      } else {
        this.goNext();
      }
    },
    handleDialogClose() {
      this.dialogPayment = false;
    },
    goNext() {
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },
    home() {
      const {
        no,
        extPos,
        orderNo,
        tableIndexNo,
        people,
      } = this.$store.getters;
      let homeUrl = `/?no=${base64Encode(no)}`;
      if (extPos && extPos.ext) {
        homeUrl += `&ext=${base64Encode(extPos.ext)}`;
      }
      if (orderNo.length > 0) {
        homeUrl += `&order=${base64Encode(orderNo)}`;
      }
      if (tableIndexNo.length > 0) {
        homeUrl += `&tableIndex=${tableIndexNo}`;
      }
      if (people === true) {
        homeUrl += '&people=true';
      }
      this.$router.replace(homeUrl);
    },
    getTableStatus() {
      const client = mqtt.connect(`wss://${mqttConfig.url}`, // eslint-disable-line
        {
          username: mqttConfig.username,
          password: mqttConfig.password,
        });
      client.on('connect', () => {
        const topic = `/${this.$store.getters.storeId}/tableStatus/`;
        client.subscribe(topic, { qos: 1 });
      });
      client.on('message', (topic, message) => {
        const _tables = JSON.parse(new TextDecoder('utf-8').decode(message));
        this.setTableStatusIntoInfo(_tables);
        client.end();
      });
    },

    setTableStatusIntoInfo(statuses) {
      this.tableInfoWithStatus = this.tableInfoWithStatus.map((info) => {
        const nowTableStatus = statuses.find((status) => status.tableId === info.tableId);
        if (nowTableStatus) info.tableStatus = nowTableStatus.tableStatus;
        return info;
      });
    },
  },
  mounted() {
    this.$store.dispatch('setStatus', 'BEFORE');
    const { diningIn, people } = this.$store.getters;
    if (diningIn !== 'for-here') {
      this.goNext();
    }
    if (this.$store.getters.skipBeforeOrder) {
      this.goNext();
    }
    if (people === true) {
      this.showKeyInGuests = true;
    } else {
      this.getTableStatus();
      this.showKeyInGuests = false;
      this.showSelectTables = true;
    }
    this.tableInfoWithStatus = this.$store.getters.tableInfo;
    if (this.showSelectTables === true && this.tableInfoWithStatus.length === 0) {
      this.goNext();
    }
  },
  computed: {
    language: {
      get() {
        return this.$store.getters.language;
      },
      set(value) {
        this.$store.dispatch('setLanguage', value);
      },
    },
    bannerHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '100px';
        case 'sm':
          return '160px';
        default:
          return '240px';
      }
    },
  },
};
</script>
<style>
.code-input input {
  max-height: none;
  letter-spacing: 16px;
}
</style>
